// modules
import map from './modules/map';
// styles
import './styles/mobile.css';

const modules = Object.freeze({ map });

const init = () =>
  Object.keys(modules).reduce(
    (acct, key) => ({ ...acct, [key]: modules[key] }),
    { inited: true },
  );

// TODO: find the better way
window.CoveyIq = init();
